import { HttpContextToken } from '@angular/common/http';

// Requests flagged with this token bypass the global spinner and global error banner.
export const SKIP_GLOBAL_HTTP_UI = new HttpContextToken<boolean>(() => false);
